import { string, object } from 'yup';

export const schema = object().shape({
  assigned_passenger: string().email('invalidEmailAddress'),
  creator_passenger: string().email('invalidEmailAddress'),
});